import { post } from "axios";
(function () {
  const TRACKER_API = "pcs-register";
  const clickedLinks = new Set(); // Store clicked hrefs to prevent duplicates

  $("a").on("click", (e) => {
    const href = e.target.pathname;
    if (href && href.length > 2 && !clickedLinks.has(href)) {
      clickedLinks.add(href); // Add clicked href to the set

      post(`/${TRACKER_API}`, {
        slug: href,
      })
        .then(function (response) {
          console.log("Tracking data sent successfully:", response.data);
        })
        .catch(function (error) {
          console.error("Error sending tracking data:", error.response.data);
        });
    }
  });
})();